// Ошибки в консоль, как $exceptionHandler и $log в AngularJS. Вызов идёт через window.console:
// рабочая сборка сайта (UglifyJS с drop_console) удаляет прямые вызовы console.*, а AngularJS
// с CDN эти ошибки печатал.
export function reportError(...args) {
    const log = window.console;
    if (log && log.error) {
        log.error(...args);
    }
}

export function reportWarning(...args) {
    const log = window.console;
    if (log && log.warn) {
        log.warn(...args);
    }
}
